import { v4 as uuidV4 } from 'uuid';

import {
  type DerivedEventFilterLegacy,
  type DerivedEventLegacy,
  DerivedEventTypeLegacy,
  type FilterLegacy,
} from '@verantos-dev/types-cohorts';
import { Merged_eventContext } from '@verantos-dev/util-cohort-builder-typescript-runtime';

import getActualValueFromDSL from './getActualValueFromDSL';
import { getEventName, getEventDateAttributes } from './getDerivedEventFilters';

const getMergedEvents = (
  event: Merged_eventContext | null,
  dirty?: boolean // set to true to annotate input fields as dirty
): DerivedEventLegacy => {
  try {
    const filters = event?.merged_event_criteria()?.merged_event_criterion();
    const criteriaFilter = event
      ?.merged_event_filter_criterion()
      ?.merged_event_filter()
      ?.merged_event_uniqueness_filter()
      ?.merged_event_uniqueness_filter_criteria();
    const eventFilters: DerivedEventFilterLegacy[] = [];
    const uniquenessFilters: FilterLegacy[] = [];
    if (filters) {
      filters.forEach((filter) => {
        if (filter.merged_event_event()) {
          eventFilters.push({
            id: uuidV4(),
            eventName: {
              id: uuidV4(),
              value: getEventName(filter?.merged_event_event()),
              dirty,
            },
            eventDateAttribute: {
              id: uuidV4(),
              value: getEventDateAttributes(filter.merged_event_event()),
              dirty,
            },
          });
        }
      });
    }
    if (criteriaFilter) {
      uniquenessFilters.push({
        id: uuidV4(),
        inputFields: criteriaFilter
          ? [
              {
                id: uuidV4(),
                value:
                  criteriaFilter
                    .derived_uniqueness_filter_window()
                    ?.derived_fixed_window_uniqueness_filter()
                    ?.FIXED_WINDOW()
                    .getText() ||
                  criteriaFilter
                    .derived_uniqueness_filter_window()
                    ?.derived_rolling_window_uniqueness_filter()
                    ?.ROLLING_WINDOW()
                    .getText() ||
                  '',
                dirty,
              },
              {
                id: uuidV4(),
                value:
                  criteriaFilter
                    ?.derived_uniqueness_filter_window()
                    ?.derived_fixed_window_uniqueness_filter()
                    ?.derived_event_int()
                    .INT()
                    .getText() ||
                  criteriaFilter
                    ?.derived_uniqueness_filter_window()
                    ?.derived_rolling_window_uniqueness_filter()
                    ?.derived_event_int()
                    .getText() ||
                  '',
                dirty,
              },
              {
                id: uuidV4(),
                value:
                  criteriaFilter
                    ?.derived_uniqueness_filter_window()
                    ?.derived_fixed_window_uniqueness_filter()
                    ?.TIME_UNIT()
                    .getText() ||
                  criteriaFilter
                    ?.derived_uniqueness_filter_window()
                    ?.derived_rolling_window_uniqueness_filter()
                    ?.TIME_UNIT()
                    .getText() ||
                  '',
                dirty,
              },
              {
                id: uuidV4(),
                value: criteriaFilter?.DERIVED_EVENT_DATE().getText() || '',
                dirty,
              },
            ]
          : [],
      });
    }

    return {
      id: uuidV4(),
      name: getActualValueFromDSL(event?.MERGED_EVENT_NAME()?.getText()) || '',
      type: DerivedEventTypeLegacy.MERGED,
      anyOrder: false,
      temporalConstraints: [],
      eventFilters: eventFilters,
      uniquenessFilters: uniquenessFilters,
    };
  } catch (error) {
    console.error('Error fetching merged events', error);
    return {} as DerivedEventLegacy;
  }
};

export default getMergedEvents;
